export default __webpack_public_path__ + "static/topic9-984305b414a109bf8135a0768915e0ea.png";